import React, { useState } from 'react';
import {
    FormControl,
    Typography,
    Button,
    TextField,
    Checkbox,
    FormControlLabel,
    Box,
    Paper,
} from '@mui/material';
import SearchFilter from '../../Requirement/components/common/SearchFilter';
import DataTable from '../../Requirement/components/common/ReusableTable';

const tableData = [
    {
        "sl_no": 1,
        "user_name": "Alice Smith",
        "user_type": "Buyer",
        "role": "Admin",
        "email_id": "alice.s@example.com",
        "status": "Active",
        "created_on": "2023-01-10"
    },
    {
        "sl_no": 2,
        "user_name": "Bob Johnson",
        "user_type": "Supplier",
        "role": "User",
        "email_id": "bob.j@example.com",
        "status": "Pending",
        "created_on": "2023-03-22"
    },
    {
        "sl_no": 3,
        "user_name": "Charlie Brown",
        "user_type": "Buyer",
        "role": "Editor",
        "email_id": "charlie.b@example.com",
        "status": "Active",
        "created_on": "2023-05-01"
    },
    {
        "sl_no": 4,
        "user_name": "Diana Prince",
        "user_type": "Supplier",
        "role": "Admin",
        "email_id": "diana.p@example.com",
        "status": "Inactive",
        "created_on": "2023-06-15"
    }
];

const BuyerAllUsers = () => {
    const [formData, setFormData] = useState({
        userName: '',
        firstName: '',
        lastName: '',
        mobileNo: '',
        emailId: '',
        role: '',
        userType: '',
    });

    const [errors, setErrors] = useState({
        userName: '',
        firstName: '',
        lastName: '',
        mobileNo: '',
        emailId: '',
        role: '',
        userType: '',
    });

    const [searchValues, setSearchValues] = useState({
        userName: "",
        userType: "All Types",
        role: "All Roles",
        email: "",
        status: "All Statuses",
    });

    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rowStart, setRowStart] = useState(0);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error when user starts typing
        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const handleRoleChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            role: checked ? name : prev.role,
        }));
        // Clear role error when a role is selected
        if (checked) {
            setErrors((prev) => ({
                ...prev,
                role: '',
            }));
        }
    };

    const handleUserTypeChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            userType: checked ? name : prev.userType,
        }));
        // Clear userType error when a user type is selected
        if (checked) {
            setErrors((prev) => ({
                ...prev,
                userType: '',
            }));
        }
    };

    const handleAdd = () => {
        if (isFormVisible && !isEditMode) {
            setIsFormVisible(false);
        } else {
            setFormData({
                userName: '',
                firstName: '',
                lastName: '',
                mobileNo: '',
                emailId: '',
                role: '',
                userType: '',
            });
            setErrors({
                userName: '',
                firstName: '',
                lastName: '',
                mobileNo: '',
                emailId: '',
                role: '',
                userType: '',
            });
            setIsEditMode(false);
            setIsFormVisible(true);
        }
    };

    const handleRowClick = (row) => {
        setIsEditMode(true);
        setIsFormVisible(true);
        setSelectedRow(row);
        setFormData({
            userName: row.user_name || '',
            firstName: row.user_name.split(' ')[0] || '',
            lastName: row.user_name.split(' ')[1] || '',
            mobileNo: '',
            emailId: row.email_id || '',
            role: row.role || '',
            userType: row.user_type || '',
        });
        setErrors({
            userName: '',
            firstName: '',
            lastName: '',
            mobileNo: '',
            emailId: '',
            role: '',
            userType: '',
        });
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            userName: '',
            firstName: '',
            lastName: '',
            mobileNo: '',
            emailId: '',
            role: '',
            userType: '',
        };

        if (!formData.userName.trim()) {
            newErrors.userName = 'Field is required';
            isValid = false;
        }
        if (!formData.firstName.trim()) {
            newErrors.firstName = 'Field is required';
            isValid = false;
        }
        if (!formData.lastName.trim()) {
            newErrors.lastName = 'Field is required';
            isValid = false;
        }
        if (!formData.mobileNo.trim()) {
            newErrors.mobileNo = 'Field is required';
            isValid = false;
        }
        if (!formData.emailId.trim()) {
            newErrors.emailId = 'Field is required';
            isValid = false;
        }
        if (!formData.role) {
            newErrors.role = 'Please select a role';
            isValid = false;
        }
        if (!formData.userType) {
            newErrors.userType = 'Please select a user type';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        setLoading(true);
        setTimeout(() => {
            console.log('Submitted Form Data:', {
                ...formData,
                mode: isEditMode ? 'UPDATE' : 'CREATE',
            });
            setSubmitted(true);
            setLoading(false);
            setIsFormVisible(false);
            setFormData({
                userName: '',
                firstName: '',
                lastName: '',
                mobileNo: '',
                emailId: '',
                role: '',
                userType: '',
            });
            setErrors({
                userName: '',
                firstName: '',
                lastName: '',
                mobileNo: '',
                emailId: '',
                role: '',
                userType: '',
            });
        }, 1000);
    };

    const fields = [
        {
            name: "userName",
            label: "User Name",
            type: "text",
            onChange: (value) => setSearchValues((prev) => ({ ...prev, userName: value })),
            value: searchValues.userName,
        },
        {
            name: "userType",
            label: "User Type",
            type: "dropdown",
            options: ["All Types", "Buyer", "Supplier"],
            onChange: (value) => setSearchValues((prev) => ({ ...prev, userType: value })),
            value: searchValues.userType,
        },
        {
            name: "role",
            label: "Role",
            type: "dropdown",
            options: ["All Roles", "Admin", "User", "Editor"],
            onChange: (value) => setSearchValues((prev) => ({ ...prev, role: value })),
            value: searchValues.role,
        },
        {
            name: "email",
            label: "Email Id",
            type: "text",
            onChange: (value) => setSearchValues((prev) => ({ ...prev, email: value })),
            value: searchValues.email,
        },
        {
            name: "status",
            label: "Status",
            type: "dropdown",
            options: ["All Status", "Active", "Inactive", "Pending"],
            onChange: (value) => setSearchValues((prev) => ({ ...prev, status: value })),
            value: searchValues.status,
        },
    ];

    const columns = [
        { id: "sl_no", numeric: false, label: "SL.NO" },
        { id: "user_name", numeric: false, label: "USER NAME" },
        { id: "user_type", numeric: false, label: "USER TYPE" },
        { id: "role", numeric: false, label: "ROLE" },
        { id: "email_id", numeric: false, label: "EMAIL ID" },
        {
            id: "status",
            numeric: false,
            label: "STATUS",
            renderCell: (row) => {
                let bgColor = "";
                let textColor = "";

                switch (row.status) {
                    case "Pending":
                        bgColor = "#fef3c7";
                        textColor = "#b45309";
                        break;
                    case "Active":
                        bgColor = "#d1fae5";
                        textColor = "#065f46";
                        break;
                    case "Inactive":
                        bgColor = "#fee2e2";
                        textColor = "#991b1b";
                        break;
                    default:
                        bgColor = "#f3f4f6";
                        textColor = "#374151";
                }

                return (
                    <span
                        style={{
                            backgroundColor: bgColor,
                            color: textColor,
                            padding: "4px 10px",
                            borderRadius: "999px",
                            fontSize: "0.75rem",
                            fontWeight: 500,
                        }}
                    >
                        {row.status}
                    </span>
                );
            },
        },
        { id: "created_on", numeric: false, label: "CREATED ON" },
    ];

    const handleSearch = () => {
        setRowStart(0);
    };

    return (
        <div className="container">
            <div className="table-header-re">
                <div className="head-btn">
                    <button className="submit-btn-more" onClick={handleAdd}>
                        {isFormVisible ? (isEditMode ? "Cancel" : "Cancel") : "Add New User"}
                    </button>
                </div>
            </div>
            <Paper elevation={2} sx={{ p: 3 }}>
                <div className="search-filter4">
                    <div className="title4">
                        <div className="head-text">All Users</div>
                    </div>
                    <div className="filter4">
                        <SearchFilter fields={fields} onSearch={handleSearch} />
                    </div>
                </div>
                <div className="table-content">
                    <DataTable
                        columns={columns}
                        data={tableData}
                        onRowClick={handleRowClick}
                    />
                </div>

                {isFormVisible && (
                    <div className='raise-ticket'>
                        <div className="table-header">
                            <div className="header-text">
                                <div className="head-subtext">
                                    {isEditMode
                                        ? "Update user details."
                                        : "Fill in the details below to create a new user account."}
                                </div>
                            </div>
                            <div className="head-btn">
                                <div className="submit-btn-form">
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        form="userForm"
                                        disabled={loading}
                                    >
                                        {loading
                                            ? 'Submitting...'
                                            : isEditMode
                                                ? 'Update'
                                                : submitted
                                                    ? 'Submitted'
                                                    : 'Submit'}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <form id="userForm" onSubmit={handleSubmit}>
                            <div className="row gx-3">
                                <FormControl className="col-md-6 mb-3" required sx={{ pr: 1 }}>
                                    <Typography variant="body2" gutterBottom>
                                        User Name *
                                    </Typography>
                                    <TextField
                                        name="userName"
                                        value={formData.userName}
                                        onChange={handleChange}
                                        placeholder="Enter user name"
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        required
                                        error={!!errors.userName}
                                        helperText={errors.userName}
                                    />
                                </FormControl>

                                <FormControl className="col-md-6 mb-3" required sx={{ pl: 1 }}>
                                    <Typography variant="body2" gutterBottom>
                                        First Name *
                                    </Typography>
                                    <TextField
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        placeholder="Enter first name"
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        required
                                        error={!!errors.firstName}
                                        helperText={errors.firstName}
                                    />
                                </FormControl>

                                <FormControl className="col-md-6 mb-3" required sx={{ pr: 1 }}>
                                    <Typography variant="body2" gutterBottom>
                                        Last Name *
                                    </Typography>
                                    <TextField
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        placeholder="Enter last name"
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        required
                                        error={!!errors.lastName}
                                        helperText={errors.lastName}
                                    />
                                </FormControl>

                                <FormControl className="col-md-6 mb-3" required sx={{ pl: 1 }}>
                                    <Typography variant="body2" gutterBottom>
                                        Mobile No *
                                    </Typography>
                                    <TextField
                                        name="mobileNo"
                                        value={formData.mobileNo}
                                        onChange={handleChange}
                                        placeholder="Enter mobile number"
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        required
                                        error={!!errors.mobileNo}
                                        helperText={errors.mobileNo}
                                    />
                                </FormControl>

                                <FormControl className="col-md-6 mb-3" required sx={{ pr: 1 }}>
                                    <Typography variant="body2" gutterBottom>
                                        Email ID *
                                    </Typography>
                                    <TextField
                                        name="emailId"
                                        value={formData.emailId}
                                        onChange={handleChange}
                                        placeholder="Enter email ID"
                                        fullWidth
                                        sx={{ backgroundColor: 'white' }}
                                        required
                                        error={!!errors.emailId}
                                        helperText={errors.emailId}
                                    />
                                </FormControl>

                                <FormControl className="col-md-12 mb-3" required sx={{ pl: 1, display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="body2" gutterBottom>
                                        Role *
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <FormControlLabel
                                            control={<Checkbox name="Buyer-Admin" onChange={handleRoleChange} checked={formData.role === "Buyer-Admin"} />}
                                            label="Buyer-Admin"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Buyer-Tread User" onChange={handleRoleChange} checked={formData.role === "Buyer-Tread User"} />}
                                            label="Buyer-Tread User"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Buyer-Finance User" onChange={handleRoleChange} checked={formData.role === "Buyer-Finance User"} />}
                                            label="Buyer-Finance User"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Supplier-Admin" onChange={handleRoleChange} checked={formData.role === "Supplier-Admin"} />}
                                            label="Supplier-Admin"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Supplier-Tread User" onChange={handleRoleChange} checked={formData.role === "Supplier-Tread User"} />}
                                            label="Supplier-Tread User"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Supplier-Finance User" onChange={handleRoleChange} checked={formData.role === "Supplier-Finance User"} />}
                                            label="Supplier-Finance User"
                                            sx={{ mr: 2 }}
                                        />
                                    </Box>
                                    {errors.role && (
                                        <Typography variant="caption" color="error">
                                            {errors.role}
                                        </Typography>
                                    )}
                                </FormControl>

                                <FormControl className="col-md-12 mb-3" required sx={{ pl: 1, display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="body2" gutterBottom>
                                        User Type *
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                        <FormControlLabel
                                            control={<Checkbox name="Tread User" onChange={handleUserTypeChange} checked={formData.userType === "Tread User"} />}
                                            label="Tread User"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Finance User" onChange={handleUserTypeChange} checked={formData.userType === "Finance User"} />}
                                            label="Finance User"
                                            sx={{ mr: 2 }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox name="Admin" onChange={handleUserTypeChange} checked={formData.userType === "Admin"} />}
                                            label="Admin"
                                            sx={{ mr: 2 }}
                                        />
                                    </Box>
                                    {errors.userType && (
                                        <Typography variant="caption" color="error">
                                            {errors.userType}
                                        </Typography>
                                    )}
                                </FormControl>
                            </div>
                        </form>
                    </div>
                )}
            </Paper>
        </div>
    );
};

export default BuyerAllUsers;